import BigNumber from 'bignumber.js';

export class SpotPricer {
  settledPrices: any = {};
  price: BigNumber

  getPrice() {
    return this.price;
  }

  getSettledPrice(expiry: number) {
    return this.settledPrices[expiry] || new BigNumber(0);
  }
}
